type Interval = {
	uuid: string;
	label: string;
	value: string;
};

export const intervals: Interval[] = [
	{
		uuid: "9d6e1d75-fed9-4eaa-9e6a-2e969cf3f8dd",
		label: "Last Week",
		value: "last-week",
	},
	{
		uuid: "9d6e1d75-fee3-4be0-be0c-b67665e56cf5",
		label: "Last Month",
		value: "last-month",
	},
	{
		uuid: "9d6e1d75-fee5-4ad2-8e20-9bdcea73bc6b",
		label: "Last Year",
		value: "last-year",
	},
];
